module.exports = __webpack_public_path__ + "img/gather-h.a7fe2632.png";